import React from 'react';
import PropTypes from 'prop-types';
import jsonp from 'jsonp';

// import profilePic from './profile-pic.jpg'
import { Column, Row } from './Skeleton';
import { Button } from './Button';
import { Input } from "./Input";


const getAjaxUrl = url => url.replace('/post?', '/post-json?');

const MAILCHIMP_URL =
  'https://github.us14.list-manage.com/subscribe/post?u=48490aae9f51a0a035867d59d&amp;id=60a94923c7';

class EmailSignupCTA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
      msg: null
    };
  }

  onSubmit = e => {
    e.preventDefault();
    // Error Case
    if (
      !this.input.value ||
      this.input.value.length < 5 ||
      this.input.value.indexOf('@') === -1
    ) {
      this.setState({
        status: 'error'
      });
      return;
    }

    const url =
      getAjaxUrl(MAILCHIMP_URL) +
      `&EMAIL=${encodeURIComponent(this.input.value)}`;
    this.setState(
      {
        status: 'sending',
        msg: null
      },
      () =>
        jsonp(
          url,
          {
            param: 'c'
          },
          (err, data) => {
            if (err) {
              this.setState({
                status: 'error',
                msg: err
              });
            } else if (data.result !== 'success') {
              this.setState({
                status: 'error',
                msg: data.msg
              });
            } else {
              this.setState({
                status: 'success',
                msg: data.msg
              });
            }
          }
        )
    );
  };

  render() {
    const { status } = this.state;

    const messages = {
      inputPlaceholder: 'Your Email',
      btnLabel: 'Sign Me Up',
      sending: 'Getting you on the list...',
      success: 'Thanks, check your email!',
      error: "Huh, that email didn't seem to work!"
    };

    const styles = {
      sending: {
        color: 'auto'
      },
      success: {
        color: 'green'
      },
      error: {
        color: 'red'
      }
    };

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'center'}}>
          <form action={MAILCHIMP_URL} method="post" noValidate>
            <div>
              <input
                ref={node => (this.input = node)}
                type="email"
                defaultValue=""
                name="EMAIL"
                required={true}
                placeholder={'Your Email Address'}
                style={{
                  color: '#444',
                  backgroundColor: '#f3f3f3',
                  border: 'none',
                  borderRadius: 0,
                  textAlign: 'center',
                  padding: '10px 20px 10px'
                }}
              />
              <div style={{ display: 'flex', justifyContent: 'center'}}>
                <Button
                disabled={this.state.status === 'sending'}
                onClick={this.onSubmit}
                type="submit"
              >
                {messages.btnLabel}
              </Button>
              </div>
            </div>
          </form>
        </div>
        {status === 'sending' &&
        <p
            style={styles.sending}
            dangerouslySetInnerHTML={{ __html: messages.sending }}
        />}
        {status === 'success' &&
        <p
            style={styles.success}
            dangerouslySetInnerHTML={{ __html: messages.success }}
        />}
        {status === 'error' &&
        <p
            style={styles.error}
            dangerouslySetInnerHTML={{ __html: messages.error }}
        />}
      </div>
    );
  }
}

EmailSignupCTA.propTypes = {
  messages: PropTypes.object,
  styles: PropTypes.object
};

export default EmailSignupCTA;



// WEBPACK FOOTER //
// ./src/components/EmailSignupCTA.js